import type { SelectChangeEvent } from "@mui/material";
import { MenuItem, Select } from "@mui/material";

export type CustomerSelectionOption = {
  value: string;
  label: string;
};

export type CustomerSelectionInputProps = {
  selectedCustomer: string;
  setSelectedCustomer: (value: string) => void;
  options: CustomerSelectionOption[];
  isLoading: boolean;
};

const CustomerSelectionInput = ({
  selectedCustomer,
  setSelectedCustomer,
  options,
  isLoading,
}: CustomerSelectionInputProps) => (
  <Select
    value={selectedCustomer}
    onChange={(e: SelectChangeEvent<string>) =>
      setSelectedCustomer(e.target.value)
    }
    size="small"
    sx={{ minWidth: "200px" }}
    disabled={isLoading}
  >
    {options.map((el) => (
      <MenuItem key={el.value} value={el.value}>
        {el.label}
      </MenuItem>
    ))}
  </Select>
);

export { CustomerSelectionInput };
